import { setRoutes } from '@wellesley/router'
import { BrandLayout } from '../../layouts/BrandLayout'
import { Outlet, RouteObject } from 'react-router-dom'
import { AuthTabsPage } from '../../pages/AuthTabsPage'
import { ForgotPasswordProcess } from '@wellesley/auth'
import { UpdateUsernamePage } from '../../pages/UpdateUsernamePage'
import { AboutServerPage } from '../../pages/AboutServerPage'

const brandRoutesDef = {
  element: (
    <BrandLayout>
      <Outlet />
    </BrandLayout>
  ),
  children: [
    {
      path: '/signin',
      element: <AuthTabsPage />,
    },
    {
      path: '/signup/:inviteCode?',
      element: <AuthTabsPage />,
    },
    {
      path: '/signup/update-username/:hash',
      element: <UpdateUsernamePage />,
    },
    {
      path: '/forgot-password',
      element: <ForgotPasswordProcess />,
    },
  ] as const,
} as const satisfies RouteObject

const hostRoutesDef = [
  {
    path: '/about',
    element: <AboutServerPage />,
  },
] as const satisfies RouteObject[]

export const brandRoutes: RouteObject = brandRoutesDef
export const hostRoutes: RouteObject[] = [...hostRoutesDef, brandRoutesDef]

setRoutes([brandRoutes, ...hostRoutes])

type BrandRoutes = (typeof brandRoutesDef)['children'][number]['path']
export type HostRoutes = (typeof hostRoutesDef)[number]['path'] | BrandRoutes
